/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_RankInputs */



/**
* | output |
* | --- |
* | "Rank" |
*
* @param {Tfield_RankInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_rank = /** @type {((inputs?: Tfield_RankInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_RankInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rang")
	if (locale === "es") return /** @type {LocalizedString} */ ("Rango")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Categoria")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rank")
	return /** @type {LocalizedString} */ ("Rank")
});